import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import SpinnerComponent from "../../../../Components/Loding/Spinner";

import {
    InserirTentativaDeContatoController,
    ListarResultadoTentativaContato,
} from "../../../../Controllers/Cobranca/ResultadoContato/ResultadoContatoController";
import { IResultadoContato } from "../../../../Interfaces/Cobranca/ResultadoContato/ResultadoContatoInterface";
import { useAtedimento } from "../../../../Context/Atendimento";
import { useHistory } from "react-router-dom";
import { ACESSOS } from "../../../../Routes/Acessos";
import { SeletorMultiCasoContato } from "../SeletorMultiCasoContato";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";

interface ITentativaDeContatoProps {
    setShow: (show: boolean) => void;
    ID_CASO: number;
}
interface ITentativaContatoForm {
    resultado_contato: number;
    justificativa: string;
}

export default function TentativaDeContato(props: ITentativaDeContatoProps) {
    const history = useHistory();

    const { ID_CASO } = props;
    const [lstIdCasoExtra, setLstIdCasoExtra] = useState<Array<number>>([]);

    const { register, formState, handleSubmit } = useForm();
    const { FL_MODO_ATENDIMENTO, goToNextAtendimento } = useAtedimento();

    const [optionsResultadoContato, setOptionsResultadoContato] =
        useState<Array<IResultadoContato>>();
    const [SpinnerShow, setSpinnerShow] = useState(false);
    const [ButtonSpinner, setButtonSpinner] = useState(false);

    const resultadoTentativaContato = optionsResultadoContato?.filter(
        (option) => option.FL_ATIVO
    );

    useEffect(() => {
        ListarResultadoTentativaContato().then((res) => {
            setOptionsResultadoContato(res);
        });
    }, []);

    function handleTentativaContatoFormSubmit(formData: ITentativaContatoForm) {
        setButtonSpinner(true);
        InserirTentativaDeContatoController({
            ID_CASO_COBRANCA_RESULTADO_CONTATO: formData.resultado_contato,
            ID_CASOs: [ID_CASO, ...lstIdCasoExtra],
            Justificativa: formData.justificativa,
        })
            .then(() => {
                setButtonSpinner(true);
                if (FL_MODO_ATENDIMENTO) {
                    setSpinnerShow(true);
                    goToNextAtendimento()
                        .then(() => {
                            props.setShow(false);
                        })
                        .finally(() => {
                            setSpinnerShow(false);
                        });
                } else {
                    setButtonSpinner(false);
                    props.setShow(false);
                    history.push(
                        ACESSOS.COBRANCA.TELAS.GESTAO_ATENDIMENTOS.DS_PATH
                    );
                }
            })
            .catch(() => {
                setButtonSpinner(false);
            });
    }

    if (optionsResultadoContato && !SpinnerShow) {
        return (
            <form onSubmit={handleSubmit(handleTentativaContatoFormSubmit)}>
                <div className="col-12 p-0">
                    <label htmlFor="resultado_contato">
                        Resultado de Contato
                    </label>
                    <select
                        name="resultado_contato"
                        className={`form-control placeholder-dark-50 ${
                            formState.errors.resultado_contato && "is-invalid"
                        }`}
                        ref={register({
                            valueAsNumber: true,
                            required: "Insira o resultado do contato",
                        })}
                    >
                        <option></option>
                        {resultadoTentativaContato?.map((resultado, index) => (
                            <option
                                key={index}
                                value={
                                    resultado.ID_CASO_COBRANCA_RESULTADO_CONTATO
                                }
                            >
                                {resultado.DS_RESULTADO_CONTATO}
                            </option>
                        ))}
                    </select>
                    <div className="invalid-feedback">
                        {formState.errors.resultado_contato
                            ? formState.errors.resultado_contato.message
                            : ""}
                    </div>
                </div>
                <textarea
                    name="justificativa"
                    className={`form-control placeholder-dark-45 mt-5 mh-100 ${
                        formState.errors.justificativa && "is-invalid"
                    }`}
                    placeholder="Justificativa"
                    style={{ minHeight: "40px", height: "150px" }}
                    ref={register({
                        required: "Insira a justificativa",
                    })}
                />
                <div className="invalid-feedback">
                    {formState.errors.justificativa
                        ? formState.errors.justificativa.message
                        : ""}
                </div>

                <SeletorMultiCasoContato
                    onChange={setLstIdCasoExtra}
                    ID_CASO={ID_CASO}
                />

                {ButtonSpinner ? (
                    <button
                        disabled
                        type="button"
                        className="btn btn-outline-success font-weight-bold d-flex col-12 align-items-center justify-content-center mt-5"
                    >
                        <Spinner size="sm" />
                        <div className="ml-2">Confirmar Contato</div>
                    </button>
                ) : (
                    <button className="btn btn-outline-success font-weight-bold d-flex col-12 justify-content-center mt-5">
                        Confirmar Contato
                    </button>
                )}
            </form>
        );
    } else if (SpinnerShow) {
        return (
            <div className="mt-4">
                <SpinnerComponent />
                <div className="d-flex justify-content-center align-items-center mt-4 mr-5">
                    Buscando Próximo Atendimento
                </div>
            </div>
        );
    } else {
        return <SpinnerComponent />;
    }
}
